import { createContext, memo, ReactNode, useContext } from 'react';

export type SettingsFlowContextProps = {};

export const SettingsFlowContext = createContext<
  SettingsFlowContextProps | undefined
>(undefined);

const kContext: SettingsFlowContextProps = {};

export const SettingsFlowContextProvider = memo(
  ({ children }: { children?: ReactNode }) => {
    return (
      <SettingsFlowContext.Provider value={kContext}>
        {children}
      </SettingsFlowContext.Provider>
    );
  },
);

export const useSettingsContext = () => useContext(SettingsFlowContext);
